import type { LayoutComponentMap } from '@nsftx/seven-client-retail-vue-common'
import SSBareLayout from './SSBareLayout.vue'
import SSBaseLayout from './SSBaseLayout.vue'
import SSPageLayout from './SSPageLayout.vue'
import SSLoginLayout from './SSLoginLayout.vue'
import SSGameLayout from './SSGameLayout.vue'

export const posLayouts = {
  BareLayout: SSBareLayout,
  BaseLayout: SSBaseLayout,
  PageLayout: SSPageLayout,
  LoginLayout: SSLoginLayout,
  GameLayout: SSGameLayout,
} satisfies LayoutComponentMap

export type PosLayouts = typeof posLayouts
